import { callApi } from '../../utils/apiCaller'
import {
  USER_ME_PATH,
  USER_CREDIT_CARDS_PATH,
  USER_WALLET_RECORDS_PATH,
  USER_WALLET_ADD_VALUE_PATH,
} from '../routes'

export const fetchMe = () => {
  return callApi(`${USER_ME_PATH}`, {
    method: 'get',
  })
}

export const fetchCreditCards = () => {
  return callApi(`${USER_CREDIT_CARDS_PATH}`, {
    method: 'get',
  })
}

export const addCreditCard = (cardToken) => {
  return callApi(`${USER_CREDIT_CARDS_PATH}`, {
    method: 'post',
    body: {
      card_token: cardToken,
    },
  })
}

export const fetchWalletRecords = (offset) => {
  return callApi(`${USER_WALLET_RECORDS_PATH}`, {
    method: 'get',
    params: {
      offset,
    },
  })
}

export const addWalletValue = (cardId, amount) => {
  return callApi(`${USER_WALLET_ADD_VALUE_PATH}`, {
    method: 'post',
    body: {
      card_id: cardId,
      amount,
    },
  })
}

export default {}
